<template lang="pug">
	header(class="header-component")
		dx-toolbar(class="header-toolbar lr-padding")
			dx-item(v-if="$auth.authenticated()", :visible="menuToggleEnabled", location="before", css-class="menu-button")
				dx-button(icon="menu",  styling-mode="text", @click="toggleMenuFunc", slot-scope="_")

			dx-item(location="before", css-class="header-title dx-toolbar-label")
				div(slot-scope="_")
					img(src="../assets/logo_transparent.png", height="35px")

			dx-item(location="after")
				div(slot-scope="_")
					.flex-row.align-center.space.font-small.wrap.mobile-hidden
						span {{$tCaption('Need help? Check our')}}
						a(href="https://wedelsoft.atlassian.net/wiki/spaces/AP", target="_blank") {{$tCaption('documentation')}}
						span {{$tCaption('or')}}
						a(@click.prevent="$router.push({ path: '/training-videos' })") {{$tCaption('Explainer Videos')}}
			dx-item(location="after")
				.job-notifier(slot-scope="_")
					PersistentJobMenuNotifier()

			dx-item(location="after")
				.bell-item(slot-scope="_")
					DxDropDownButton.no-text(
						icon="far fa-bell",
						:showArrowIcon="false"
						:items="notifications.map((f, i) => ({ id: i, ...f }))",
						display-expr="message",
						key-expr="id",
						:drop-down-options="{ width: 230, onHidden: () => { notifications.map(f => f.isNew = false); } }"
						width="28px",
						height="28px",
						styling-mode="text",
						:focusStateEnabled="false",
						:wrapItemText="true",
						:noDataText="$tCaption('No notifications')"
					)
						template(v-slot:item="{ data }")
							.bell-message.flex-col.align-end(v-if="data.message")
								.flex-row.space-medium.align-center.full-width
									fas.info-icon(:icon="data.icon || 'info-circle'", :class="[data.type]")
									.bell-item-text(v-html="data.message")
								.time {{data.time}}
							.flex-col.center.align-center.full-height(v-else)
								.bell-notification-icon(:class="{ active: !!newNotifications.length }")
									.far.fa-bell
								LoadingLine.full-width(v-if="!!notificationsBusyStatus")
					.messages-indicator.flex-row.align-center.center(:class="{ active: !!newNotifications.length }")
						span {{newNotifications.length}}

			dx-item(v-if="false", location="after")
				.language-wrapper(slot-scope="_")
					language-select-box(
						:value.sync="selectedLanguage"
						placeholder="Language"
						:items="$locale.state.availableLocales"
						value-expr="code"
						display-expr="label",
						:compact="true"
					)

			dx-item(location="after", locate-in-menu="auto", menu-item-template="menuUserItem")
				div(slot-scope="_")
					dx-button(class="user-button authorization", :maxWidth="240", height="100%", styling-mode="text")
						div
							UserPanel(:menu-items="userMenuItems", menu-mode="context")
			UserPanel(:menu-items="userMenuItems", menu-mode="list", slot-scope="_", slot="menuUserItem")
</template>

<script>
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DxButton from "devextreme-vue/button";
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import auth from "../auth";
import UserPanel from "./user-panel.vue";
import LanguageSelectBox from "@/components/LanguageSelectBox";
import LoadingLine from 'app-core/LoadingLine.vue';
import PersistentJobMenuNotifier from 'view/persistentJob/MenuNotifier.vue';

export default {
	components: { LanguageSelectBox, DxButton, DxToolbar, DxItem, UserPanel, DxDropDownButton, LoadingLine, PersistentJobMenuNotifier },
	props: {
		menuToggleEnabled: Boolean,
		title: String,
		toggleMenuFunc: Function,
		logOutFunc: Function
	},
	data() {
		const userMenuItems = [
			{
				text: 'Profile',
				icon: 'card',
				onClick: this.onProfileClick
			},
			{
				text: 'Logout',
				icon: 'runner',
				onClick: this.onLogoutClick,
				index: 999
			}
		];
		return {
			userMenuItems,
			selectedLanguage: null,
			isChanging: false,
			notifications: [],
			notificationsBusyStatus: 0
		};
	},
	computed: {
		newNotifications() {
			return this.notifications.filter(f => f.isNew);
		}
	},	
	watch: {
		'$locale.state.currentLocale.code'(v) {
			this.isChanging = true;
			this.selectedLanguage = v;
			setImmediate(() => {
				if (this._isDestroyed) return;
				this.isChanging = false;
			})
		},
		selectedLanguage(curr, prev) {
			if (this.isChanging) return;
			localStorage.setItem('locale', curr)
			this.$locale.actions.refreshI18n(true);
		}
	},
	mounted() {
		this.selectedLanguage = this.$locale.state.currentLocale.code;
		if (__DEBUG__)
			window.headerToolbar = this;
		this.$eventsBus.$on('notification-message', this.onNotification);
		this.$eventsBus.$on('notification-busy', this.onNotificationBusy);
		this.$eventsBus.$on('notification-busy-clear', this.onNotificationBusyClear);

		if (this.$auth.hasAccessToCompanyProfile() || this.$auth.isAdmin()) {
			this.userMenuItems.splice(1, 0, {
				text: 'Organization',
				icon: 'product',
				onClick: this.onOrganizationClick
			});
			if ((this.$auth.isStationOwner() && this.$auth.hasAccessToCompanyProfile()) || this.$auth.isAdmin()) {
				this.userMenuItems.push({
					text: 'My AdServers licenses',
					icon: 'fas fa-certificate',
					onClick: this.onLicensesClick
				});
			}
		}
	},
	destroyed() {
		this.$eventsBus.$off('notification-message', this.onNotification);
		this.$eventsBus.$off('notification-busy', this.onNotificationBusy);
		this.$eventsBus.$off('notification-busy-clear', this.onNotificationBusyClear);
	},
	methods: {
		onNotification(notification) {
			this.notifications.splice(0,0,{ ...notification, isNew: true, time: this.$moment().format('LLL') });
			if (this.notifications.length > 10) {
				this.notifications.splice(10, 1);
			}
		},
		onNotificationBusy(val) {
			if (val)
				this.notificationsBusyStatus++;
			else
				this.notificationsBusyStatus--;

			if (this.notificationsBusyStatus < 0)
				this.notificationsBusyStatus = 0;
		},
		onNotificationBusyClear() {
			this.notificationsBusyStatus = 0;
		},
		onLogoutClick() {
			auth.logOut();
			this.$router.push({
				path: '/login-form',
				query: { redirect: this.$route.path }
			});
		},
		onProfileClick() {
			this.$router.push({ path: '/profile' });
		},
		onOrganizationClick() {
			this.$router.push({ path: '/company/profile' });
		},
		onLicensesClick() {
			this.$router.push({ path: '/licenses' });
		}
	}
};
</script>

<style lang="scss">
	@import "../themes/generated/variables.base.scss";
	@import "../dx-styles-params.scss";

	@import "main/themes/generated/variables.base.scss";

	.bell-message {
		padding: 5px 10px 5px 10px !important;

		.time {
			font-size: 9px;
			color: rgba(0,0,0,0.4);
		}

		.bell-item-text {
			font-size: 11px;
		}

		.info-icon {
			&.success {
				color: #15d639;
			}
			&.error {
				color: #ff6060;
			}
			&.info {
				color: #bababa;
			}
		}
	}

	.header-component {
		flex: 0 0 auto;
		z-index: 1;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

		.dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
			color: $base-accent;
		}
		.bell-item {
			position: relative;
			cursor: pointer;
			transition: 0.3s;
			transform: scale(1);

			&:hover{
				transform: scale(1.1);
			}

			.bell-notification-icon {
				width: 22px;
				height: 22px;
				opacity: 0.25;
				transition: 0.3s;
				margin-bottom: 2px;

				&.active, &:hover {
					opacity: 1;
				}

				.fa-bell {
					width: 100%;
					height: 100%;
				}
			}

			.messages-indicator {
				position: absolute;
				right: -2px;
				top: -2px;
				padding: 0px;
				height: 0px;
				background: #f27649;
				border-radius: 30px;
				font-size: 10px;
				transition: 0.3s;
				overflow-y: hidden;
				color: $base-bg;
				pointer-events: none;

				&.active {
					height: 14px;
					padding: 4px;
				}
			}
		}
	}

	.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
		padding: 0 40px;

		.screen-x-small & {
			padding: 0 20px;
		}
	}

	.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
		width: $side-panel-min-width;
		text-align: center;
		padding: 0;
	}

	.header-title .dx-item-content {
		padding: 0;
		margin: 0;
	}

	.dx-theme-generic {
		.dx-toolbar {
			padding: 10px 0;
		}

		.user-button > .dx-button-content {
			padding: 3px;
		}
	}
</style>
